import { Toast } from "@tandemdiabetes/sugarmate-react-components"
import { usePolyglot } from "src/contexts"

interface Props {
  id: string;
}

export function DeleteFollowerErrorToast(props: Props) {
  const polyglot = usePolyglot()

  return (
    <Toast
      stylePreset="error"
      body={polyglot.t("toasts.remove_follower_error.body")}
      id={props.id}
    />
  )
}